import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

type Params = { program_purse_id: number }
type Payload = { program_id: number; bank_account_id: number }
type Request = { params: Params; payload: Payload }

async function setPurseBankAccount({ params, payload }: Request) {
  try {
    await axios.put(
      `program_purses/${params.program_purse_id}/bank_account`,
      payload
    )
    return null
  } catch {
    throw new Error('Failed to assign bank account to purse')
  }
}

export const useSetPurseBankAccount = () => {
  return useMutation({
    mutationFn: setPurseBankAccount,
  })
}
